
import {
  Component, Prop, Ref, Mixins,
} from 'vue-property-decorator';
import ResponsivenessMixin from '../mixins/responsivenessMixin';
import TooltipSidebar from './TooltipSidebar.vue';
import SidePanel from './SidePanel.vue';

@Component({
  components: {
    TooltipSidebar,
    SidePanel,
  },
})
export default class Tooltip extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) text!: string;

  @Prop({ default: '' }) title!: string;

  @Prop({ default: false }) isDelay!: boolean;

  @Prop({ default: false }) bottom!: boolean;

  @Prop({ default: false }) left!: boolean;

  @Prop({ default: 400 }) maxWidth!: number;

  @Prop({ default: 200 }) minWidth!: number;

  @Ref('activator') activator!: HTMLElement;

  private isAnimatedOpen = false;

  // eslint-disable-next-line class-methods-use-this
  private onActivatorPointerDown(e: MouseEvent): void {
    e.stopPropagation();
  }

  private handleClick(): void {
    this.isAnimatedOpen = true;
  }

  private closeSidebar(): void {
    this.isAnimatedOpen = false;
  }
}
